import type { ProductId } from "./products/product-id";

const sortByType = ["MANUAL", "TITLE", "PRICE"] as const;
const sortDirections = ["ASCENDING", "DESCENDING"] as const;
type SortByType = (typeof sortByType)[number];
type SortDirection = (typeof sortDirections)[number];

type SortSettings = {
    sortBy: SortByType;
    sortDirection: SortDirection;
    sortOrder?: ProductId[];
};

const defaultSortSettings: SortSettings = {
    sortBy: "TITLE",
    sortDirection: "ASCENDING",
    sortOrder: [],
};

export { defaultSortSettings, sortByType, sortDirections };
export type { SortByType, SortDirection, SortSettings };
